// Copyright (c) 2017 Deere & Company

import actions from '../../action-list';

export const updateListFilterBy = filterBy => ({
    payload: filterBy,
    property: 'filterBy',
    type: actions.UPDATE_DEALER_INVOICE_FILTER_BY
});

export const updateListSortBy = sortBy => ({
    payload: sortBy,
    property: 'sortBy',
    type: actions.UPDATE_DEALER_INVOICE_SORT_BY
});

export const updateListSortDirection = sortDirection => ({
    payload: sortDirection,
    property: 'sortDirection',
    type: actions.UPDATE_DEALER_INVOICE_SORT_DIRECTION
});



// WEBPACK FOOTER //
// ./src/claim/dealer-invoices/action-creators/search-filters.js